import { Input, Textarea, Label } from '@creanizer/ui'
import type { CharacterAppearance } from '@creanizer/types'

interface AppearanceEditorProps {
  appearance: CharacterAppearance
  onChange: (appearance: CharacterAppearance) => void
}

export function AppearanceEditor({
  appearance,
  onChange
}: AppearanceEditorProps) {
  const handleChange = (field: keyof CharacterAppearance, value: string) => {
    onChange({
      ...appearance,
      [field]: value
    })
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label htmlFor="height">身長</Label>
          <Input
            id="height"
            value={appearance.height}
            onChange={(e) => handleChange('height', e.target.value)}
            placeholder="例: 175cm"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="weight">体重</Label>
          <Input
            id="weight"
            value={appearance.weight || ''}
            onChange={(e) => handleChange('weight', e.target.value)}
            placeholder="例: 65kg"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="build">体格</Label>
          <Input
            id="build"
            value={appearance.build}
            onChange={(e) => handleChange('build', e.target.value)}
            placeholder="例: 筋肉質"
            className="mt-1"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="hairColor">髪の色</Label>
          <Input
            id="hairColor"
            value={appearance.hairColor}
            onChange={(e) => handleChange('hairColor', e.target.value)}
            placeholder="例: 黒"
            className="mt-1"
          />
        </div>
        
        <div>
          <Label htmlFor="hairStyle">髪型</Label>
          <Input
            id="hairStyle"
            value={appearance.hairStyle}
            onChange={(e) => handleChange('hairStyle', e.target.value)}
            placeholder="例: ショートカット"
            className="mt-1"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="eyeColor">瞳の色</Label>
          <Input
            id="eyeColor"
            value={appearance.eyeColor}
            onChange={(e) => handleChange('eyeColor', e.target.value)}
            placeholder="例: 茶色"
            className="mt-1"
          />
        </div>
        
        <div>
          <Label htmlFor="distinctiveMarks">特徴的な印</Label>
          <Input
            id="distinctiveMarks"
            value={appearance.distinctiveMarks || ''}
            onChange={(e) => handleChange('distinctiveMarks', e.target.value)}
            placeholder="例: 左頬に傷跡"
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="facialFeatures">顔立ちの特徴</Label>
        <Textarea
          id="facialFeatures"
          value={appearance.facialFeatures}
          onChange={(e) => handleChange('facialFeatures', e.target.value)}
          placeholder="例: シャープな輪郭で、鼻筋が通っている"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="clothing">服装</Label>
        <Textarea
          id="clothing"
          value={appearance.clothing}
          onChange={(e) => handleChange('clothing', e.target.value)}
          placeholder="例: 黒いローブに革のベルト"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="overallImpression">全体的な印象</Label>
        <Textarea
          id="overallImpression"
          value={appearance.overallImpression}
          onChange={(e) => handleChange('overallImpression', e.target.value)}
          placeholder="例: 威厳があり、近寄りがたい雰囲気を持つ"
          rows={3}
          className="mt-1"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="voiceQuality">声質</Label>
          <Input
            id="voiceQuality"
            value={appearance.voiceQuality || ''}
            onChange={(e) => handleChange('voiceQuality', e.target.value)}
            placeholder="例: 低くて落ち着いた声"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="posture">姿勢</Label>
          <Input
            id="posture"
            value={appearance.posture || ''}
            onChange={(e) => handleChange('posture', e.target.value)}
            placeholder="例: 背筋が伸びている"
            className="mt-1"
          />
        </div>
      </div>
    </div>
  )
}